import { TextField } from "@mui/material";

export interface ListTextFieldProps {
    value: string[];
    onChange: (value: string[]) => void;
    rows?: number;
    label: string;
    name: string;
    helperText?: string;
    required?: boolean;
    disabled?: boolean;
}

export default function ListTextField(props: ListTextFieldProps) {

    const lineSeparator = "\n";

    const { value, onChange, rows, label, name, helperText, required, disabled } = props;

    function getValue(): string {
        return value.join(lineSeparator);
    }

    function onChangeHandler(list: string) {
        const values = list.trim() ? list.split(lineSeparator).map(t => t.trim()) : [];
        onChange(values);
    }

    return (
        <TextField
            name={name}
            label={label}
            margin="dense"
            variant="outlined"
            multiline={true}
            rows={rows || 5}
            fullWidth
            value={getValue()}
            required={required}
            onChange={e => onChangeHandler(e.target.value)}
            helperText={helperText}
            disabled={disabled}
        />
    );
}